import React, { Component, Suspense } from 'react'
import styled from 'styled-components'
import { Container, Row, Col, media } from 'styled-bootstrap-grid'
import easing from 'ui/styles/easing'
import theme from 'ui/styles/theme'

//const Doc = React.lazy(() => import('./documentExtended'));
import DocumentExtended from './documentExtended'

export default class Downloads extends Component {
  state = {
    filteredDocuments: [],
    filters: [],
    activeFilter: null,
    numPages: null,
    pageNumber: 1,
    allDocuments: []
  }

  componentDidMount() {
    const { documents } = this.props
    const filters = [];
    //this.getCustomDocuments();
    const allDocuments = this.getCustomDocuments().concat(documents);

    //Goes through available document types and adds buttons with them if 
    //specific document types exist in the currently added documents
    allDocuments.map(document => {
      if (!filters.includes(document.documentType)) {
        return filters.push(document.documentType)
      }
      return true
    })

    this.setState({
      filteredDocuments: allDocuments,
      allDocuments: allDocuments,
      filters
    })
  }

  //Gets custom documents and creates an array of objects with the same template as Post added documents
  getCustomDocuments = () => {
    console.log(this.props.custom_document)
    let documentArray = this.props.custom_document.document.map(doc => {
      console.log(doc)
      return {
        documentType: doc.document_type,
        file: {
          sourceUrl: doc.source_url
        },
        language: doc.document_language,
        product: (doc.custom_product_id !== '' && doc.custom_product_id !== 'false') ? doc.custom_product_id.replace(/['"]+/g, '') : doc.product_id.key,
        slug: doc.document_slug,
        title: doc.document_title
      }
    })
    return documentArray
  }
  returnString(needle, haystack) {
    if (haystack) {
      return haystack.find(straw => straw.slug === needle).title
    } else {
      return needle
    }
  }

  onDocumentLoadSuccess = ({ numPages }) => {
    this.setState({ numPages });
  }

  setFilter(filter) {
    const { documents } = this.props
    const { activeFilter, allDocuments } = this.state

    if (filter === activeFilter) {
      this.setState({
        filteredDocuments: allDocuments,
        activeFilter: null
      })
    } else {
      const filteredDocuments = allDocuments.filter(document => document.documentType === filter)

      this.setState({
        activeFilter: filter,
        filteredDocuments
      })
    }
  }


  render() {
    const { languages, documentTypes, products, label, bgcolor, mod_title } = this.props
    const { filteredDocuments, filters, activeFilter } = this.state
    const { pageNumber, numPages } = this.state;

    return (
      <Wrapper id={'downloads'} bgcolor={bgcolor}>
        <HeroWrapper fluid>
          <Row>
            <Col sm={10} >
              <h2>{mod_title}</h2>
            </Col>
          </Row>
          <Row>
            <Col sm={10} >
              <Filters>
                {filters.map(filter => (
                  <FilterButton
                    onClick={() => this.setFilter(filter)}
                    active={filter === activeFilter}
                    key={filter}
                  >
                    {this.returnString(filter, documentTypes)}
                  </FilterButton>
                ))}
              </Filters>
            </Col>
          </Row>
          <Row>
            <Col >
              <DocumentExtended
                filteredDocuments={filteredDocuments}
                products={products}
                languages={languages}
                pageNumber={pageNumber}
              />
            </Col>
          </Row>
        </HeroWrapper>
      </Wrapper>
    )
  }
}

// Styles
const Wrapper = styled.section`
  margin-bottom: 65px;
  background-color: ${props => props.bgcolor === 'white' ? 'white' : theme.colors.tones.lightest};
  padding: 1em 0;
`

const Filters = styled.div`
  display: flex;
  margin-bottom: 32px;
`

const HeroWrapper = styled(Container)`
                    padding: 0 20px;
                    ${media.lg`
                    padding: 0 20%;
                    `}
                    `


const FilterButton = styled.button`
  background: ${props => props.active ? props.theme.colors.primary : 'white'};
  color: ${props => props.active ? 'white' : props.theme.colors.text};
  margin-right: 10px;
  border: 1px solid ${props => props.theme.colors.text};
  outline: none;
  padding: 0.5em 1.5em;
  border-radius: 2em;
  font-size: 10px;
  opacity: ${props => props.active ? 1 : 0.35};
  border-color: ${props => props.active ? props.theme.colors.primary : props.theme.colors.text};
  transition: all 0.3s ${easing.easeOutCubic};

  &:hover {
    cursor: pointer;
  }
`




// WEBPACK FOOTER //
// ./src/ui/components/modules/Downloads/index.js